// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1dhfz","noInteraction":"EventWrapper_noInteraction__30M_r"};